import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=ab4b0712&scoped=true"
import script from "./journal.vue?vue&type=script&lang=ts"
export * from "./journal.vue?vue&type=script&lang=ts"
import style0 from "./journal.vue?vue&type=style&index=0&id=ab4b0712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4b0712",
  null
  
)

export default component.exports